import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import PageMeta from "./PageMeta";

function NotFound() {
  return (
    <main className="content-page not-found-page">
      <PageMeta title="Page not found" noIndex />
      <section className="page-hero page-hero--centered">
        <div className="page-shell page-hero__content">
          <p className="eyebrow">Error 404</p>
          <h1>This page is not in the pantry.</h1>
          <p className="page-hero__lede">
            The link may be out of date, or the page may have moved. Let’s get
            you back to {siteConfig.brandName}.
          </p>
          <div className="page-hero__actions">
            <Link className="button button--primary" to="/">
              Return home
            </Link>
            <Link className="button button--secondary" to="/shop">
              Browse the shop
            </Link>
          </div>
        </div>
      </section>

      <section className="page-section page-shell not-found-links">
        <h2>Looking for something else?</h2>
        <div className="link-card-grid">
          <Link className="link-card" to="/about">
            <span>Our story</span>
            <span aria-hidden="true">→</span>
          </Link>
          <Link className="link-card" to="/shipping">
            <span>Shipping information</span>
            <span aria-hidden="true">→</span>
          </Link>
          <Link className="link-card" to="/contact">
            <span>Contact customer care</span>
            <span aria-hidden="true">→</span>
          </Link>
        </div>
      </section>
    </main>
  );
}

export default NotFound;
